<template>
  <div class="services-sidebar-section buy-number">
    <input class="input-hidden-for-safari" type="email">
    <multiselect :placeholder="placeholderServices" label="title" :closeOnSelect="true" :internal-search="false"
                 @search-change="searchServicesFunc" @select="changeSelectedService" :preserve-search="false"
                 @open="changeFocusSearchService(true)" @close="changeFocusSearchService(false)" :showLabels="false"
                 :options="searchServicesListWrapper" :option-height="40" :multiple="true" aria-autocomplete="none"
                 name="service-name">
      <template slot="caret" slot-scope="{ toggle }">
        <span class="span-buy-number">1</span>
        <img @mousedown.prevent.stop="toggle()" class="multiselect__select multiselect__select__img"
             src="/img/svg/common/search-black.svg" alt="caret icon"/>
      </template>
      <template v-slot:placeholder>
        <span class="service-select-label">1</span><span
          :class="{ 'placeholder--span': true, 'placeholder--selected': selected }">{{ placeholderServices }}</span>
      </template>
      <template v-slot:noResult>
        {{ getLocalization('No elements found. Change search') }}
      </template>
      <template slot="option" slot-scope="props">
        <img :src="props.option.img_path">
        <span>{{ getLocalization(props.option.title) }}</span>
      </template>
    </multiselect>

    <div v-if="isMounted" class="grid-container-phone-list">
      <div :class="{ 'grid-item': true, '--selected': selectedService.id === service.id }"
           @click="changeSelectedService(service)" v-for="(service, index) in searchServicesList" :key="index">
        <div class="phone-list-border"></div>
        <img class="img-radius" :src="service.img_path"/>
      </div>
    </div>
    <div v-else class="grid-container-phone-list --more">
      <template v-for="() in this.popularCount">
        <div class="no-service-icon animated-background"></div>
      </template>
    </div>

    <div class="services-sidebar-new-noty" :class="{ 'new-service-noty-ru': isRussianLanguage }">
      <p>{{ getLocalization('If the desired service is not on the list, contact') }}
        <a href="https://t.me/smsbower_support_bot" target="_blank"
           class="support-new-service-link">{{ getLocalization('support') }}</a>
      </p>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  name: "serviceSidebarSectionNumber",
  components: {
    Multiselect
  },
  props: {
    placeholderServices: {
      type: String,
      required: true
    },
    selectedService: {
      type: Object,
      required: true
    },
    isFocusSearchService: {
      type: Boolean,
      required: true
    },
    isMounted: {
      type: Boolean,
      required: true
    },
    popularCount: {
      type: Number,
      required: true
    },
    searchServicesListWrapper: {
      type: Array,
      required: true
    },
    searchServicesList: {
      type: Array,
      required: true
    },
    isRussianLanguage: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      selected: true
    };
  },
  methods: {
    searchServicesFunc(newVal) {
      this.$emit('search-services', newVal);
    },
    changeSelectedService(service) {
      this.$emit('select-service', service);
    },
    changeFocusSearchService(isFocused) {
      this.$emit('focus-search', isFocused);
    }
  }
}
</script>
<style scoped></style>
